import { environment } from 'src/environments/environment';
declare var config: any;

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Socket } from 'ngx-socket-io';

@Injectable()
export class SocketProvider {

  sockerUrl = environment.SOCKET_URL;
  pingtime = null;
  ignoreCache = true;

  constructor(
    public http: HttpClient,
    public socket: Socket,
  ) {
    console.log('Hello SocketProvider Provider');
  }

  getBidsByCategory(id:number) {

    return new Promise((resolve, reject) => {

      this.http.get(this.sockerUrl + '/getBids/' + id).subscribe( resp => {
        return resolve(resp);
      }, err => {
        return reject(err);
      });
    });
  }

  connect() {

    // Handle disconnect event
    this.socket.fromEvent('disconnect').subscribe( () => {
      console.log("Websocket 'disconnect' event");
    });

    // pong to our ping
    this.socket.fromEvent('pong').subscribe( (data: any) => {
      if(data.id == this.pingtime) {
        // console.log(Date.now() - pingtime + " ms")
        // document.getElementById('ping').innerHTML = Date.now() - pingtime + " ms";
      }
      else {
        // console.log("pong failed:", data.id, pingtime);
      }
    });

    // Listen for server hello event
    this.socket.fromEvent('hello').subscribe( (data: any) => {
      console.log("Server says:", data.greeting);

      // Start heartbeat timer
      this.heartbeat();
    });
  }

  auctionSold(data:any){

    this.socket.emit('auctionSold', data);
  }

  updateCategoryJobs(data:any){
    this.socket.emit('updateCategoryJobs', data);
  }

  updateAuctionJob(data:any){
    this.socket.emit('updateAuctionJob', data);
  }

  clearAuctions(data:any){
    this.socket.emit('clearAuctions', data);
  }

  auctionMinvalue(data:any){
    this.socket.emit('auctionMinvalue', data);
  }
  // Keep pinging and ponging with server
  heartbeat() {

    // Create heartbeat
    setTimeout( () => { this.heartbeat() }, config.heartbeattmo);

    this.pingtime = Date.now();
    this.socket.emit('ping', {id: this.pingtime});
  };

  refreshVirtualLot(){
    this.socket.emit('refreshVirtualLot', {});
  }

}
